import React, { useCallback, useEffect, useState } from "react";
import {
  and,
  filter,
  fromPairs,
  includes,
  map,
  mergeRight,
  omit,
  pluck,
  toPairs,
  pickBy,
} from "ramda";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";

import DialogContent from "@material-ui/core/DialogContent";
import { lensProp, set } from "ramda";
import Grid from "@material-ui/core/Grid";
import { FetchError } from "../util/fetchUtils";
import { useDispatch } from "react-redux";
import { logOut } from "../auth/authActions";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { notBlank } from "../util/ext";
import {
  useContentProviderEndpoint,
  useContentProviderEndpointCreate,
  useContentProviderEndpointUpdate,
} from "./contentProviderServices";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import { Box, List, ListItem, ListItemText, MenuItem } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Skeleton } from "@material-ui/lab";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

const Alert = React.forwardRef((props, ref) => {
  return <MuiAlert elevation={6} variant="filled" ref={ref} {...props} />;
});

const useStyles = makeStyles(theme => ({
  multiPicker: {
    "& label.MuiFormLabel-root": {
      backgroundColor: "#fff",
      marginLeft: "-5px",
      padding: "0 6px",
    },
  },

  title: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },

  list: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.primary.dark,
  },

  checkboxLabelPlacement: {
    marginLeft: 0,
  },

  emptyList: {
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: theme.palette.primary.dark,
    fontSize: "1.2rem",
    fontStyle: "italic",
    padding: theme.spacing(2),
    color: theme.palette.primary.main,
  },
}));

const initialState = {
  fields: {
    name: "",
    filePath: "",
    metadataParser: "",
    defaultModules: [],
    overrides: {},
    defaults: {},
    forceIsbn: false,
    disableArchive: false,
    autoApprove: false,
    active: true,
  },
};

const ProviderEndpointDialog = ({
  open,
  contentProvider,
  contentProviderEndpointId,
  modules,
  onClose,
  onSave,
}) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const [fields, setFields] = useState(initialState.fields);
  const [errorAlert, setErrorAlert] = useState({ open: false });

  const onFieldChanged = field => value => {
    console.log(value);
    const val = value.target ? value.target.value : value;
    const fieldValue = val === "null" || val === "none" ? "" : val;

    const update = set(lensProp(field), fieldValue, fields);
    setFields(update);
  };

  const onCheckboxChanged = field => event => {
    const val = event.target.checked;
    const update = set(lensProp(field), val, fields);
    setFields(update);
  };

  const [selectedModules, setSelectedModules] = useState([]);
  const handleModulesChange = useCallback((_event, modules) => {
    setSelectedModules(modules);
  }, []);

  const [overrides, setOverrides] = useState({});
  const [override, setOverride] = useState({ field: "", value: "" });
  const handleOverrideChange = field => value => {
    const val = value.target ? value.target.value : value;
    const update = set(lensProp(field), val, override);

    setOverride(update);
  };

  const handleAddOverride = () => {
    const newObj = fromPairs([[override.field, override.value]]);
    const update = mergeRight(overrides, newObj);
    setOverrides(update);
    setOverride({ field: "", value: "" });
  };

  const handleRemoveOverride = field => {
    const update = omit([field], overrides);
    setOverrides(update);
  };

  const [defaults, setDefaults] = useState({});
  const [fieldDefault, setFieldDefault] = useState({ field: "", value: "" });
  const handleDefaultChange = field => value => {
    const val = value.target ? value.target.value : value;
    const update = set(lensProp(field), val, fieldDefault);

    setFieldDefault(update);
  };

  const handleAddDefault = () => {
    const newObj = fromPairs([[fieldDefault.field, fieldDefault.value]]);
    const update = mergeRight(defaults, newObj);
    setDefaults(update);
    setFieldDefault({ field: "", value: "" });
  };

  const handleRemoveDefault = field => {
    const update = omit([field], defaults);
    setDefaults(update);
  };

  const cpeResult = useContentProviderEndpoint(
    contentProvider.id,
    contentProviderEndpointId,
  );
  useEffect(() => {
    if (cpeResult.isSuccess && cpeResult.data != null) {
      const contentProviderEndpoint = cpeResult.data;
      console.log(contentProviderEndpoint);
      const cpeFields = {
        name: contentProviderEndpoint.name,
        location: contentProviderEndpoint.location,
        metadataParser: contentProviderEndpoint.metadataParser,
        contentProviderId: contentProvider.id,
        defaultModules: notBlank(contentProviderEndpoint.defaultModules)
          ? contentProviderEndpoint.defaultModules
          : [],
        overrides: notBlank(contentProviderEndpoint.overrides)
          ? contentProviderEndpoint.overrides
          : {},
        defaults: notBlank(contentProviderEndpoint.defaults)
          ? contentProviderEndpoint.defaults
          : {},
        disableArchive: notBlank(contentProviderEndpoint.disableArchive)
          ? contentProviderEndpoint.disableArchive || false
          : false,
        autoApprove: notBlank(contentProviderEndpoint.autoApprove)
          ? contentProviderEndpoint.autoApprove || false
          : false,
      };
      setFields(cpeFields);
      setOverrides(cpeFields.overrides);
      setDefaults(cpeFields.defaults);

      if (and(notBlank(modules), notBlank(cpeFields.defaultModules))) {
        setSelectedModules(
          filter(
            module => includes(module.id, cpeFields.defaultModules),
            modules,
          ),
        );
      }
    }
  }, [
    contentProviderEndpointId,
    contentProvider,
    modules,
    setFields,
    setOverrides,
    setDefaults,
    setSelectedModules,
    cpeResult.isSuccess,
    cpeResult.data,
  ]);

  const showAlert = message =>
    setErrorAlert({
      open: true,
      message,
    });

  const handleError = useCallback(
    (message, err = {}) => {
      if (err instanceof FetchError) {
        if (err.status === 401) {
          dispatch(logOut());
        } else {
          showAlert(message);
        }
      } else {
        if (notBlank(err)) {
          showAlert(err.message);
        } else {
          showAlert(message);
        }
      }
    },
    [dispatch],
  );

  const contentProviderEndpointCreate = useContentProviderEndpointCreate();
  const contentProviderEndpointUpdate = useContentProviderEndpointUpdate();
  const handleOnSave = useCallback(async () => {
    if (notBlank(fields.name)) {
      const mergedEndpoint = mergeRight(fields, {
        defaultModules: pluck("id", selectedModules),
        overrides,
        defaults,
        contentProviderId: contentProvider.id,
        active: true,
        id: contentProviderEndpointId,
      });

      try {
        if (notBlank(contentProviderEndpointId)) {
          await contentProviderEndpointUpdate.mutateAsync({
            resourceIds: {
              contentProviderId: contentProvider.id,
              contentProviderEndpointId,
            },
            data: pickBy(notBlank, mergedEndpoint),
          });
        } else {
          await contentProviderEndpointCreate.mutateAsync({
            resourceIds: { contentProviderId: contentProvider.id },
            data: pickBy(notBlank, mergedEndpoint),
          });
        }

        onSave(fields);
      } catch (err) {
        handleError("Unable to save Content Provider Endpoint.", err);
      }
    } else {
      handleError("Content Provider Endpoint Name is required.");
    }
  }, [
    handleError,
    onSave,
    contentProviderEndpointCreate,
    contentProviderEndpointUpdate,
    fields,
    selectedModules,
    overrides,
    defaults,
    contentProvider,
    contentProviderEndpointId,
  ]);

  const handleOnClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Dialog open={open} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">New Content Provider</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Enter a data for the new Content Provider Endpoint.
        </DialogContentText>
        <Grid container spacing={2} alignItems="flex-end">
          <Grid item xs={12}>
            <TextField
              id="name"
              label="Name"
              fullWidth
              value={fields.name || ""}
              onChange={onFieldChanged("name")}
            />
          </Grid>

          <Grid item xs={8}>
            <TextField
              id="filePath"
              label="File Path"
              fullWidth
              value={fields.location || ""}
              onChange={onFieldChanged("location")}
            />
          </Grid>

          <Grid item xs={6}>
            <FormControl fullWidth={true}>
              <InputLabel shrink id="parser-select-placeholder-label-label">
                Parser
              </InputLabel>
              <Select
                labelId="parser-select-placeholder-label-label"
                id="parser-select-placeholder-label"
                value={fields.metadataParser || ""}
                onChange={onFieldChanged("metadataParser")}
              >
                <MenuItem key="none" value="">
                  --
                </MenuItem>
                <MenuItem key="biblio-csv" value="BIBLIO_CSV">
                  BiblioLabs CSV
                </MenuItem>
                <MenuItem key="onix-21" value="ONIX_21">
                  ONIX 2.1
                </MenuItem>
                <MenuItem key="onix-30" value="ONIX_30">
                  ONIX 30
                </MenuItem>
                <MenuItem key="opds-v2" value="OPDS_V2">
                  OPDS 2
                </MenuItem>
                <MenuItem key="wiley-ml-xml" value="WILEY_ML_XML">
                  Wiley XML
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={fields.autoApprove}
                  onChange={onCheckboxChanged("autoApprove")}
                  name="autoApprove"
                  color="primary"
                />
              }
              labelPlacement="start"
              label="Auto Approve"
              classes={{
                labelPlacementStart: classes.checkboxLabelPlacement,
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={fields.disableArchive}
                  onChange={onCheckboxChanged("disableArchive")}
                  name="disableArchive"
                  color="primary"
                />
              }
              labelPlacement="start"
              label="Disable Archive"
              classes={{
                labelPlacementStart: classes.checkboxLabelPlacement,
              }}
            />
          </Grid>

          <Grid item sm={12}>
            {notBlank(modules) ? (
              <Box mt={4} className={classes.multiPicker}>
                <Autocomplete
                  multiple
                  id="modules"
                  options={modules}
                  getOptionLabel={option => option.name}
                  value={selectedModules || []}
                  filterSelectedOptions
                  onChange={handleModulesChange}
                  renderInput={params => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Default Modules"
                      placeholder="Select..."
                    />
                  )}
                />
              </Box>
            ) : (
              <Skeleton variant="text" />
            )}
          </Grid>

          {/* Overrides */}
          <Grid item xs={12}>
            <Typography variant="body1" className={classes.title}>
              Overrides
            </Typography>
            {notBlank(overrides) ? (
              <List classes={{ root: classes.list }}>
                {map(
                  override => (
                    <ListItem key={override[0]}>
                      <ListItemText
                        primary={override[0] + " -> " + override[1]}
                      />
                      <ListItemSecondaryAction>
                        <IconButton
                          onClick={() => handleRemoveOverride(override[0])}
                          edge="end"
                          aria-label="delete"
                        >
                          <CloseIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ),
                  toPairs(overrides),
                )}
              </List>
            ) : (
              <Box className={classes.emptyList}>Add an override...</Box>
            )}
          </Grid>
          <Grid item xs={5}>
            <TextField
              id="override-field"
              label="Field Name"
              type="text"
              value={override.field}
              onChange={handleOverrideChange("field")}
              fullWidth
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              id="override-value"
              label="Value"
              type="text"
              value={override.value}
              onChange={handleOverrideChange("value")}
              fullWidth
            />
          </Grid>
          <Grid item xs={2}>
            <div>
              <Button
                onClick={handleAddOverride}
                variant="text"
                color="primary"
              >
                Add
              </Button>
            </div>
          </Grid>

          {/* Defaults */}
          <Grid item xs={12}>
            <Typography variant="body1" className={classes.title}>
              Defaults
            </Typography>
            {notBlank(defaults) ? (
              <List classes={{ root: classes.list }}>
                {map(
                  def => (
                    <ListItem key={def[0]}>
                      <ListItemText primary={def[0] + " -> " + def[1]} />
                      <ListItemSecondaryAction>
                        <IconButton
                          onClick={() => handleRemoveDefault(def[0])}
                          edge="end"
                          aria-label="delete"
                        >
                          <CloseIcon />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  ),
                  toPairs(defaults),
                )}
              </List>
            ) : (
              <Box className={classes.emptyList}>Add a default...</Box>
            )}
          </Grid>
          <Grid item xs={5}>
            <TextField
              id="default-field"
              label="Field Name"
              type="text"
              value={fieldDefault.field}
              onChange={handleDefaultChange("field")}
              fullWidth
            />
          </Grid>
          <Grid item xs={5}>
            <TextField
              id="default-value"
              label="Value"
              type="text"
              value={fieldDefault.value}
              onChange={handleDefaultChange("value")}
              fullWidth
            />
          </Grid>
          <Grid item xs={2}>
            <div>
              <Button onClick={handleAddDefault} variant="text" color="primary">
                Add
              </Button>
            </div>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOnClose} color="primary">
          Cancel
        </Button>
        <Button onClick={handleOnSave} color="primary">
          Save
        </Button>
      </DialogActions>

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={errorAlert.open}
        autoHideDuration={6000}
        onClose={() => setErrorAlert(mergeRight(errorAlert, { open: false }))}
      >
        <Alert
          onClose={() => setErrorAlert(mergeRight(errorAlert, { open: false }))}
          severity="error"
        >
          {errorAlert.message}
        </Alert>
      </Snackbar>
    </Dialog>
  );
};

export default ProviderEndpointDialog;
